import { useSearchParams } from "react-router";
import { SnowCanvas } from "../components/SnowCanvas"

export const OverlayPage = () => {

    const [searchParams] = useSearchParams();

    if (searchParams) {
        return (
            <SnowCanvas
                intensity={Number(searchParams.get('intensity'))}
                fallSpeed={Number(searchParams.get('fallSpeed'))}
                wind={Number(searchParams.get('windDirection'))}
                snowSize={Number(searchParams.get('snowSize'))}
                accumulate={JSON.parse(searchParams.get('enableSnowDrifts'))}
                maxDriftHeight={Number(searchParams.get('maxDriftHeight'))}
                meltSimulation={JSON.parse(searchParams.get('meltSimulation'))}
                meltSpeed={Number(searchParams.get('meltSpeed'))}
                weatherSim={JSON.parse(searchParams.get('weatherSim'))}
            />
        )
    }
}